import * as React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import '@ant-design/compatible/assets/index.css';
import { Layout, Row, Col, Button, Card } from 'antd';
import PaginatedReduxTable from '../paginated_redux_table/PaginatedReduxTable';
import { EmptyState } from '../empty_state/EmptyState';
import queryString from 'querystring';
import { nullSafeGet, nullSafeGetOrElse, parseQueryParameters } from '../../utils/DataAccessUtils';
import LogOnMountWithStandardEventProperties from '../log_on_mount_with_standard_event_properties/LogOnMountWithStandardEventProperties';
import {
	projectsRestCrudThunksForBuyer,
	projectsRestCrudThunksForSupplier,
} from '../../thunks/projects_thunks';
import { PROJECTS_CRUD_ACTION_CREATORS } from '../../actions/projects_actions';
import { ProjectsRowDisplay } from '../project_row_display/ProjectsRowDisplay';
import { BUYER_ONLY_NO_STORE_ASSOCIATE } from '../roles/roles';
import { AdvancedFilters } from '../advanced_filters/AdvancedFilters';
import { Form } from '@ant-design/compatible';
import SubnavBar from '../subnav_bar/SubnavBar';
import { ROLE_TYPES } from '../../utils/DataConstants';

const PROJECTS_OVERVIEW_TARGET_COLLECTION = 'projectsIndex';
const { Content } = Layout;

class ProjectsIndexPage extends React.Component<any, any> {
	initialPagination: any = { current: 1, pageSize: 10 };
	initialFilters: any;
	initialSorting: any;

	constructor(props) {
		super(props);
		const { location, history, updateProjectsSorting, updateProjectsFilters, currentUser } =
			this.props;
		const userType = nullSafeGetOrElse('userType', currentUser, 'buyer');
		let searchString = location.search;
		if (searchString[0] === '?') {
			searchString = searchString.slice(1);
		}
		const queryParams = queryString.parse(searchString);
		const { current, pageSize, sort_by, order, ...projectFilters } = queryParams;
		this.initialPagination = { current: current ? current : 1, pageSize: pageSize ? pageSize : 10 };
		this.initialSorting = {
			sort_by: sort_by ? sort_by : 'createdAt',
			order: order ? order : 'ascend',
		};

		updateProjectsSorting(
			this.initialSorting.sort_by,
			this.initialSorting.order,
			PROJECTS_OVERVIEW_TARGET_COLLECTION
		);

		this.initialFilters =
			projectFilters && Object.keys(projectFilters).length > 0
				? {
						...projectFilters,
				  }
				: {};

		updateProjectsFilters(this.initialFilters, PROJECTS_OVERVIEW_TARGET_COLLECTION);

		this.state = {
			displayMode: 'list',
		};
		history.push(`/${userType}/projects/overview/all?${new URLSearchParams(location.search)}`);
	}

	switchDisplayMode = (mode) => this.setState({ displayMode: mode });
	isDisplayModeActive = (mode) => this.state.displayMode === mode;

	handleDelete = (project, e) => {
		const { history } = this.props;

		e.stopPropagation();
		e.preventDefault();
	};

	handleEdit = (project, e) => {
		const { history } = this.props;

		e.stopPropagation();
		e.preventDefault();
	};

	handleCancel = (project, e) => {
		const { history } = this.props;

		e.stopPropagation();
		e.preventDefault();
	};

	render() {
		const {
			projects,
			clearAndUpdateFilters,
			currentUser,
			location,
			history,
			updateProjectsFilters,
		} = this.props;
		const userType = nullSafeGetOrElse('userType', currentUser, 'buyer');
		const columns = [
			{
				title: '',
				dataIndex: this.initialSorting.sort_by,
				defaultSortOrder: this.initialSorting.order,
				order: this.initialSorting.order,
				sort_by: this.initialSorting.sort_by,
				render: (text, record) => (
					<Row style={{ width: '100%' }}>
						<ProjectsRowDisplay project={record} />
					</Row>
				),
			},
		];
		const popupRenderFunc = (record) => `
            <div style="max-width: 480px; padding: 8px;">
                <a href="/${userType}/projects/detail/${record.id}">
                    <div
                        class="projectRowDisplay__rowTitle"
                        style="margin-bottom: 8px;"
                    >
                      ${record.title}
                    </div>
                    <div class="projectRowDisplay__rowSubtitle">
                        <div class="projectRowDisplay__rowInlineGroup">
                            <i class="icons8-font icons8-location-marker"></i>
                            <span>${nullSafeGet('location.storeId', record)}</span>
                        </div>
                        <div class="projectRowDisplay__rowInlineGroup">
                            <i class="icons8-font icons8-maintenance-filled"></i>
                            <span>${nullSafeGet('spendCategory.name', record)}</span>
                        </div>
                    </div>
                </a>
            </div>
        `;

		const onRow = (record) => ({
			onClick: () => {
				let searchString = location.search;
				if (searchString[0] === '?') {
					searchString = searchString.slice(1);
				}
				let backUrl = `/${userType}/projects/detail/${record.id}/details`;
				if (searchString && searchString.length > 0) {
					backUrl = backUrl.concat(`?backlinkParams=${encodeURIComponent(searchString)}`);
				}
				history.push(backUrl);
			},
		});
		const getCreateButton = (
			<Button
				type="primary"
				size="large"
				onClick={() => this.props.history.push(`/${userType}/projects/newProject`)}
			>
				Create Project
			</Button>
		);
		let initialFilters = parseQueryParameters(location.search);
		return (
			<Content className="ProjectsIndexPage" style={{ padding: '0 0.5em' }}>
				<LogOnMountWithStandardEventProperties eventType="visited work orders index page" />
				{/*<ScrollToTopOnMount/>*/}
				{/*<BackTop/>*/}
				<Row gutter={16} style={{ margin: '0.5em' }}>
					<SubnavBar
						left={
							<AdvancedFilters
								updateFilters={updateProjectsFilters}
								filterConfig={[]}
								filtersTargetCollectionName={PROJECTS_OVERVIEW_TARGET_COLLECTION}
								clearAndUpdateFilters={clearAndUpdateFilters}
								filtersStateSlice={projects}
								initialFilters={initialFilters}
							></AdvancedFilters>
						}
						right={getCreateButton}
					/>
				</Row>
				<Row style={{ margin: '0.5em ' }}>
					<Col span={24}>
						<Card
							bodyStyle={{
								display: 'flex',
								flexDirection: 'column',
								justifyContent: 'space-between',
								padding: '12px 12px',
							}}
						>
							<PaginatedReduxTable
								tableLayoutFixed={true}
								mode={this.state.displayMode}
								updateQueryParams={true}
								longitudeAccessor={(el) => nullSafeGet('location.buyerFacility.longitude', el)}
								latitudeAccessor={(el) => nullSafeGet('location.buyerFacility.latitude', el)}
								popupRenderFunc={popupRenderFunc}
								showHeader={false}
								emptyState={
									currentUser.roles &&
									currentUser.roles.some((role) => BUYER_ONLY_NO_STORE_ASSOCIATE.has(role)) ? (
										<EmptyState
											graphic={
												<img
													style={{ marginBottom: 8 }}
													src="https://s3.amazonaws.com/mock-data-assets/categories/images/cactus.svg"
												/>
											}
											headline={"It's a little lonely in here."}
											body={
												<div style={{ textAlign: 'center' }}>
													<div style={{ maxWidth: 440, marginBottom: 16 }}>
														Looks like your team has not created any projects yet.
													</div>
													<Button
														type="primary"
														onClick={() =>
															this.props.history.push(`/${userType}/projects/newProject`)
														}
													>
														Create your first project
													</Button>
												</div>
											}
										/>
									) : (
										<EmptyState
											graphic={
												<img
													style={{ marginBottom: 8 }}
													src="https://s3.amazonaws.com/mock-data-assets/categories/images/cactus.svg"
												/>
											}
											headline={"It's a little lonely in here."}
											body={
												<div style={{ textAlign: 'center' }}>
													<div style={{ maxWidth: 440, marginBottom: 16 }}>
														Looks like your team has not created any projects.
													</div>
													<Button
														type="primary"
														onClick={() => {
															[2483, 2489, 2490].includes(
																nullSafeGet('facility.buyerCompanyId', currentUser)
															)
																? this.props.history.push(`/${userType}/projects/newProject`)
																: this.props.history.push(`/${userType}/projects/newProject`);
														}}
													>
														Create your first project
													</Button>
												</div>
											}
										/>
									)
								}
								collectionName="projects"
								targetCollectionName={PROJECTS_OVERVIEW_TARGET_COLLECTION}
								columns={columns}
								onRow={onRow}
								keyAccessor={(el) => el.id}
								initialFilters={this.initialFilters}
								initialPagination={this.initialPagination}
								initialSorting={this.initialSorting}
								fetchData={
									nullSafeGet('userType', currentUser) === ROLE_TYPES.SUPPLIER
										? projectsRestCrudThunksForSupplier.read
										: projectsRestCrudThunksForBuyer.read
								}
							/>
						</Card>
					</Col>
				</Row>
			</Content>
		);
	}
}

const mapStateToProps = (state, ownProps) => ({
	history: ownProps.history,
	locations: state.locations,
	currentUser: state.session.currentUser,
	projects: state.projects,
});

const mapDispatchToProps = (dispatch) => ({
	updateProjectsFilters: (filters, targetCollection) =>
		dispatch(PROJECTS_CRUD_ACTION_CREATORS.updateFilters(filters, targetCollection)),
	clearAndUpdateFilters: (filters, targetCollectionName) =>
		dispatch(PROJECTS_CRUD_ACTION_CREATORS.clearAndUpdateFilters(filters, targetCollectionName)),
	updateProjectsSorting: (sortBy, order, targetCollection) =>
		dispatch(PROJECTS_CRUD_ACTION_CREATORS.updateSorting(sortBy, order, targetCollection)),
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ProjectsIndexPage));
